import React, { Component } from 'react';
import { Icon, Form, Input, Button, message } from 'antd';
import Wrapper from './style';
import ContactUs from '../../components/ContactUs';
import { ResendVerificationCode } from '../../common/fetch';

class ActivationEmailRequest extends Component {
	state = {
		isOpen: false,
		num: parseInt((Math.random() * 100) % 11, 10) + 1
	};

	handleSubmit = async (e) => {
		e.preventDefault();
		const { getFieldValue } = this.props.form;
		const email = getFieldValue('email');
		if (email === undefined || email === '') return;
		try {
			const res = await ResendVerificationCode(email);
			message.success(res.data.message);
			this.props.history.replace('/login');
		} catch (error) {
			console.error(error);
			message.error('Error : ' + error.data.message);
		}
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	handleOk = (body) => {
		message.success(body);
		this.closeModal();
	};

	handleError = (body) => {
		message.error(body);
		this.closeModal();
	};

	render() {
		const { isOpen } = this.state;
		const { getFieldDecorator } = this.props.form;
		return (
			<Wrapper>
				<h3>Activation Email Request</h3>
				<Form onSubmit={this.handleSubmit}>
					<Form.Item>
						{getFieldDecorator('email', {
							rules: [
								{
									required: true,
									message: 'Please input your email!'
								},
								{
									type: 'email',
									message: 'The input is not valid E-mail!'
								}
							]
						})(
							<Input
								prefix={
									<Icon
										type="mail"
										style={{ color: '#42454D' }}
									/>
								}
								placeholder="Email"
							/>
						)}
					</Form.Item>
					<div>
						<Button block type="primary" htmlType="submit">
							Request Email
						</Button>
					</div>
				</Form>
				<div className="contact-us">
					Please check your spam folder in your email account. <br />
					If you still haven’t receieved your activation email after <br />
					sometime then please{' '}
					<span onClick={this.openModal}>contact us.</span>
				</div>
				<ContactUs
					visible={isOpen}
					defaultType="Other"
					handleOk={this.handleOk}
					handleError={this.handleError}
					handleCancel={this.closeModal}
				/>
			</Wrapper>
		);
	}
}

const WrappedActivationEmailRequest = Form.create({ name: 'login form' })(
	ActivationEmailRequest
);

export default WrappedActivationEmailRequest;
